import { AuthStateI, authTypes, getAuthTypes } from "./authTypes";

export const initialState: AuthStateI = {
  loginLoading          : false,
  loginError            : "",
  // @ts-expect-error
  user                  : {},
  didTryAutoLogin       : false,
  forgotPasswordLoading : false,
  forgotPasswordError   : "",
  helpInfoLoading       : false,
  helpInfoError         : "",
  maintenance           : {},
  users                 : [],
};

const ACTION_REDUCER = {
  [authTypes.LOGIN]: (state: AuthStateI) => ({
    ...state,
    loginLoading : true,
    loginError   : "",
  }),
  [authTypes.LOGIN_SUCCESS]: (state: AuthStateI, { payload }: getAuthTypes) => ({
    ...state,
    loginLoading    : false,
    loginError      : "",
    user            : payload,
    didTryAutoLogin : true,
  }),
  [authTypes.LOGIN_FAILURE]: (state: AuthStateI, { payload }: getAuthTypes) => ({
    ...state,
    loginLoading    : false,
    loginError      : payload,
    didTryAutoLogin : true,
  }),
  [authTypes.LOGOUT]: (state: AuthStateI) => ({
    ...state,
    loginLoading    : false,
    loginError      : "",
    user            : undefined,
    didTryAutoLogin : true,
  }),
  [authTypes.DID_TRY_AUTO_LOGIN]: (state: AuthStateI) => ({
    ...state,
    didTryAutoLogin: true,
  }),
  [authTypes.FORGOT_PASSWORD]: (state: AuthStateI) => ({
    ...state,
    forgotPasswordLoading : true,
    forgotPasswordError   : "",
  }),
  [authTypes.FORGOT_PASSWORD_SUCCESS]: (state: AuthStateI) => ({
    ...state,
    forgotPasswordLoading: false,
  }),
  [authTypes.FORGOT_PASSWORD_FAILURE]: (state: AuthStateI, { payload }: getAuthTypes) => ({
    ...state,
    forgotPasswordError   : payload,
    forgotPasswordLoading : false,
  }),
  [authTypes.GET_HELP_INFO]: (state: AuthStateI) => ({
    ...state,
    helpInfo        : undefined,
    helpInfoLoading : true,
    helpInfoError   : "",
  }),
  [authTypes.GET_HELP_INFO_SUCCESS]: (state: AuthStateI, { payload }: getAuthTypes) => ({
    ...state,
    helpInfo        : payload,
    helpInfoLoading : false,
  }),
  [authTypes.GET_HELP_INFO_FAILURE]: (state: AuthStateI, { payload }: getAuthTypes) => ({
    ...state,
    helpInfoError   : payload,
    helpInfoLoading : false,
  }),
  [authTypes.GET_USERS]: (state: AuthStateI) => ({
    ...state,
    helpInfoError: "",
  }),
  [authTypes.GET_USERS_SUCCESS]: (state: AuthStateI, { payload }: getAuthTypes) => ({
    ...state,
    users: payload,
  }),
  [authTypes.GET_USERS_FAILURE]: (state: AuthStateI, { payload }: getAuthTypes) => ({
    ...state,
    helpInfoError: payload,
  }),
  [authTypes.GET_REFRESH_TOKEN_SUCCESS]: (state: AuthStateI, { payload }: getAuthTypes) => ({
    ...state,
    user: payload,
  }),
  [authTypes.GET_REFRESH_TOKEN_FAILURE]: (state: AuthStateI) => ({
    ...state,
    user: [],
  }),
};

const reducer = (state: AuthStateI = initialState, action: getAuthTypes) => {
  const actionReducer = ACTION_REDUCER[action.type];

  return actionReducer ? actionReducer(state, action) : state;
};

export default reducer;
